import type React from 'react';
import { DoneStepView } from './DoneStepView';
import { useDoneStep } from './useDoneStep';

/** `/onboarding/done`: the imports so far, Import more and Finish. */
export const DoneStep: React.FC = () => <DoneStepView {...useDoneStep()} />;
